import React, { useState, createRef } from 'react';
import './../customer/tailwind.min.css';
import './../customer/verifications.css';
import { Link, useNavigate } from 'react-router-dom';
import Api from '../common/Api.js';
import jwt_encode from 'jwt-encode';
import jwt_decode from 'jwt-decode';

function ForgotVerify() {
  const navigate = useNavigate();

  if (localStorage.getItem('franchisee-token') !== null)
    navigate('/franchisee-dashboard');
  if (localStorage.getItem('franchisee-reset-token') !== null)
    navigate('/franchisee-reset-password');
  if (localStorage.getItem('franchisee-forgot-token') === null)
    navigate('/franchisee-forgot-password');

  const [value, setJSON] = useState(
    JSON.parse(localStorage.getItem('franchisee-forgot-token'))
  );
  const [values, setValues] = useState({
    first: '', second: '', third: '', fourth: '', fifth: '', sixth: '',
  });
  const [inputRefsArray] = useState(() => Array.from({ length: 6 }, () => createRef()));
  const [res_errors, setRes_errors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [resend, setResend] = useState();

  const handleChange = (event) => {
    const index = Number(event.target.id);
    setValues({ ...values, [event.target.name]: event.target.value });
    const nextInput = inputRefsArray?.[index < 5 ? index + 1 : 0]?.current;
    const currentInput = inputRefsArray?.[index]?.current;
    const prevInput = inputRefsArray?.[index - 1]?.current;

    if (event.key === 'Backspace') {
      currentInput.value = '';
      if (index !== 0) prevInput.focus();
      setValues({ ...values, [currentInput.name]: '' });
      event.preventDefault();
    } else if (event.keyCode > 47 && event.keyCode < 58) {
      currentInput.value = event.key;
      if (index !== 5) nextInput.focus();
      setValues({ ...values, [currentInput.name]: event.key });
      currentInput.style = '';
      event.preventDefault();
    } else if (event.keyCode > 64 && event.keyCode < 91) {
      currentInput.value = '';
      setValues({ ...values, [currentInput.name]: '' });
      event.preventDefault();
    }
  };

  const handleSubmit = async (event) => {
    if (event) event.preventDefault();
    if (!validate()) return;

    setLoading(true);
    const send = { id: value.id, mobile: value.mobile, otp: values };

    await Api.post(
      '/franchisee/forgot_check',
      jwt_encode(send, process.env.REACT_APP_SECRET_KEY)
    ).then((res) => {
      const result = jwt_decode(res.data);
      const status = result.data.status;
      setLoading(false);

      if (status === 'failure') {
        setRes_errors(result.data.errors);
        setTimeout(() => setRes_errors([]), 8000);
      } else if (status === 'success') {
        localStorage.setItem('franchisee-reset-token', JSON.stringify(result.data.data));
        localStorage.removeItem('franchisee-forgot-token');
        navigate('/franchisee-reset-password');
      }
    });
  };

  const handleResend = async () => {
    const send = { id: value.id, mobile: value.mobile, otp: values };
    await Api.post(
      '/franchisee/forgot_resend',
      jwt_encode(send, process.env.REACT_APP_SECRET_KEY)
    ).then((res) => {
      const result = jwt_decode(res.data);
      const status = result.data.status;

      if (status === 'failure') {
        setRes_errors(result.data.errors);
        setTimeout(() => setRes_errors([]), 8000);
      } else if (status === 'success') {
        setValues({ first: '', second: '', third: '', fourth: '', fifth: '', sixth: '' });
        localStorage.setItem('franchisee-forgot-token', JSON.stringify(result.data.data));
        setJSON(result.data.data);
        setResend(result.data.message);
        setTimeout(() => setResend(null), 5000);
      }
    });
  };

  const validate = () => {
    let invalid = false;
    ['first', 'second', 'third', 'fourth', 'fifth', 'sixth'].forEach((k, i) => {
      if (!values[k] || values[k].trim().length === 0) {
        const el = inputRefsArray?.[i]?.current;
        if (el) el.style = 'border: 1px solid red';
        invalid = true;
      }
    });
    return !invalid;
  };

  return (
    <section className="w3l-forms-23">
      <div className="forms23-block">
        <div className="wrapper">
          <h1>
            <Link to="#." className="logo-2" style={{ color: '#ffffff', fontWeight: '700' }}>
              DLMP21
            </Link>
          </h1>
          <div className="d-grid forms23-grids">
            <div className="form23">
              <h6 className="text-center">Forgot Password Verification</h6>
              <p className="text-center">
                Enter the OTP sent on <strong>{value.mobile}</strong> to continue.
              </p>
              <p className="text-center">
                <small className="text-info">* OTP valid till <strong>{value.valid}</strong></small>
              </p>
              <br />
              <form onSubmit={handleSubmit}>
                <div className="mb-6 text-center">
                  <div id="otp" className="flex justify-center">
                    {inputRefsArray.map((ref, index) => {
                      const name = ['first', 'second', 'third', 'fourth', 'fifth', 'sixth'][index];
                      return (
                        <input
                          key={index}
                          type="tel"
                          pattern="[0-9]{1}"
                          id={index}
                          name={name}
                          value={values[name]}
                          maxLength="1"
                          ref={ref}
                          autoFocus={index === 0}
                          onKeyDown={handleChange}
                          onChange={handleChange}
                          className="m-2 text-center form-control form-control-solid rounded focus:border-blue-400 focus:shadow-outline"
                          style={{ padding: 'unset' }}
                        />
                      );
                    })}
                  </div>
                  {res_errors.msg && <small className="text-danger">{res_errors.msg}</small>}
                  {resend && <small className="text-success">{resend}</small>}
                </div>

                <button type="submit" className="btn button-eff" style={{ padding: 'unset', height: '40px' }}>
                  <span style={{ marginLeft: '35px' }}>Verify</span>
                  <span style={{ float: 'right', width: '10px', height: '10px', marginLeft: '5px' }}>
                    {loading && <i className="fa fa-circle-o-notch fa-spin"></i>}
                  </span>
                </button>
                <p className="text-center">
                  <small>
                    * OTP not received..{' '}
                    <Link onClick={handleResend} style={{ color: 'green' }} to="#">
                      Resend OTP now !!!
                    </Link>
                  </small>
                </p>
              </form>
            </div>
            <div className="form23-text">
              <h3>
								Shop Local. Join the Network. Earn Rewards.
							</h3>

							<p>
								Discover local businesses, shop through the DLMP21 network,
								and participate in a customer reward ecosystem built around
								your everyday purchases.
							</p>

							<p>
								<strong>
									Register → Shop ₹1,000+ → Show Your DLMP Code →
									Track Your Rewards
								</strong>
							</p>
              <Link to="/" className="btn button-eff button-eff-2">
                <span className="fa fa-hand-o-left" aria-hidden="true"></span> Back to Home
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ForgotVerify;